// Copyright (c) 2016 Deere & Company

import TrackClaimContainer from '../../claim/track/state-connector';

export default {
    component: TrackClaimContainer,
    name: 'TRACK_CLAIM',
    path: 'track/new(/:pin)'
};



// WEBPACK FOOTER //
// ./src/routes/claims/track-claim-route.js